import { format } from '../libs/phone-mask-formatter'

const Phone = ({ props: { value }}) => (
	<span class="text-nowrap">{ format(value) }</span>
)

Phone.props = {
	value: {
		type: String,
		default: '',
	},
}

export default Phone
